export default __webpack_public_path__ + "static/adhdpro-4-5472b23a2265ac382ad8f890e6e45546.png";